import React from 'react';
import PropTypes from 'prop-types';
import DateFormatter from '../utils/DateFormatter';
import LinkButton from './LinkButton';
import { I18nUtils } from '../../../i18n/I18nUtils';
import DocumentState from './DocumentState';
import { DocumentUtils } from '../utils/DocumentUtils';
import TableCheckbox from './TableCheckbox';
import { PsDocument } from '../document/list/PsDocument';
import { PsDocumentRouteGenerator } from '../document/PsDocumentRouteGenerator';

export default class DocumentRow extends React.Component {

    _documentRouteGenerator = new PsDocumentRouteGenerator();

    static renderTdDocumentName(document) {
        if ( !document ) return <td/>;

        const documentName = DocumentUtils.getDocumentName(document);

        if ( document.worker || document.machine )
            return <td><strong>{documentName}</strong></td>;

        return <td>{documentName}</td>;
    }

    render() {
        const {
            checkedItemIds,
            onCheck,
            hideOutsource,
            displayContractorColumn,
            isContractorViewer,
            document: {
                id,
                company,
                end_date,
                start_date,
                document_state,
                contractor,
            },
        } = this.props;

        const showContractor = displayContractorColumn && !isContractorViewer;
        const showOutsource = isContractorViewer || !hideOutsource;

        const expirationDateString = DateFormatter.formatDate(end_date);

        const renderRowOutsource = (render) => {
            if ( render ) {
                return <td>{company ? company.name : ''}</td>;
            }
            return null;
        };

        const displayCheck = !!checkedItemIds && !!onCheck;

        return (
            <tr>
                {
                    displayCheck && (
                        <td>
                            <TableCheckbox
                                checked={checkedItemIds.includes(String(id))}
                                onChange={() => onCheck(this.props.document)}
                            />
                        </td>
                    )
                }
                <td><DocumentState state={document_state}/></td>
                {
                    showContractor && <td>{contractor ? contractor.name : ''}</td>
                }
                {renderRowOutsource(showOutsource)}
                {DocumentRow.renderTdDocumentName(this.props.document)}
                <td>{DateFormatter.formatDate(start_date)}</td>
                <td>{expirationDateString ? expirationDateString : 'N/A'}</td>
                <td>
                    <LinkButton
                        to={this.generateRoute()}
                        text={I18nUtils.tr('TR_VER_FICHA')}
                        className={'btn-sm btn-block'}
                    />
                </td>
            </tr>
        );
    }

    generateRoute = () => {
        const document = PsDocument.fromAPIDocument(this.props.document);
        return this._documentRouteGenerator.generateRoute(document);
    };
}

DocumentRow.propTypes = {
    document: PropTypes.objectOf(PropTypes.any).isRequired,
    hideOutsource: PropTypes.bool,
    displayContractorColumn: PropTypes.bool,
    isContractorViewer: PropTypes.bool,
};

DocumentRow.defaultProps = {
    hideOutsource: false,
    isContractorViewer: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/DocumentRow.jsx